import { _ as _sfc_main } from "./VaViewer.vue_vue_type_script_lang-9795aab0.mjs";
import { resolveComponent, openBlock, createElementBlock, Fragment, createElementVNode, mergeProps, renderSlot, normalizeProps, guardReactiveProps, createCommentVNode, createBlock, Teleport, createVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaViewer_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-viewer-content" };
const _hoisted_2 = {
  ref: "content",
  class: "va-viewer-content__main-area"
};
const _hoisted_3 = {
  ref: "controls",
  class: "va-viewer-content__controls-panel"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", mergeProps({ class: "va-viewer" }, _ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleAnchorClick && _ctx.handleAnchorClick(...args))
    }), [
      renderSlot(_ctx.$slots, "anchor", normalizeProps(guardReactiveProps({ openViewer: _ctx.openViewer }))),
      !_ctx.$slots.anchor ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
    ], 16),
    _ctx.isOpened ? (openBlock(), createBlock(Teleport, {
      key: 0,
      to: _ctx.teleportTarget
    }, [
      createElementVNode("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          !_ctx.$slots.image ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "image")
        ], 512),
        createElementVNode("div", _hoisted_3, [
          renderSlot(_ctx.$slots, "controls"),
          renderSlot(_ctx.$slots, "close", normalizeProps(guardReactiveProps({ close: _ctx.closeViewer })), () => [
            createElementVNode("button", {
              class: "va-viewer-content__close-button",
              onClick: _cache[1] || (_cache[1] = (...args) => _ctx.closeViewer && _ctx.closeViewer(...args))
            }, [
              createVNode(_component_va_icon, {
                name: "close",
                color: "backgroundPrimary"
              })
            ])
          ])
        ], 512)
      ])
    ], 8, ["to"])) : createCommentVNode("", true)
  ], 64);
}
const _VaViewer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaViewer as _
};

import '../../../VaViewer.css';
//# sourceMappingURL=VaViewer-55652bd2.mjs.map
